import { pipe, catchError } from 'overmind';

import type { Context } from '@/overmind';
import { getRequestAborter } from '@/overmind/effects/requestAborter';
import { UnexpectedStateError, AbortError } from '@/overmind/errors';

const { switchToNewRequest, completeRequestOperator } = getRequestAborter(
  'loadMapConfiguration'
);

export const loadMapConfiguration = pipe(
  async ({ state, effects }: Context) => {
    const abortController = switchToNewRequest();
    if (state.tenants.currentTenant.type === 'SELECTED_TENANT') {
      state.arcgis.config.send('TRIGGER_LOADING');
      const tenant = state.tenants.currentTenant.context.tenantId;
      return effects.api.networkService.getMapConfiguration(
        tenant,
        abortController
      );
    }

    throw new UnexpectedStateError();
  },
  ({ state }: Context, config) => {
    if (!config.mapSource.featurePickerGroups) {
      config.mapSource.featurePickerGroups = [
        {
          title: 'Container',
          assetTypes: [
            170, 171, 172, 173, 174, 175, 176, 177, 178, 180, 181, 182, 183, 184
          ]
        },
        {
          title: 'Power Transformer',
          assetTypes: [800, 801, 802, 803, 804, 805, 806, 807]
        },
        {
          title: 'Energy Consumers',
          assetTypes: [966, 967, 968, 969]
        },
        {
          title: 'ACLine segments',
          assetTypes: [
            920, 921, 922, 923, 928, 929, 930, 931, 932, 933, 934, 935, 936
          ]
        }
      ];
    }
    state.arcgis.config.send('FETCH_SUCCESS', config);
  },
  catchError(({ state }: Context, error) => {
    if (
      !(error instanceof UnexpectedStateError || error instanceof AbortError)
    ) {
      state.arcgis.config.send('FETCH_ERROR', error.message);
    }
  }),
  completeRequestOperator()
);

export const resetArcGisConfigState = pipe(async ({ state }: Context) => {
  state.arcgis.config.send('UNLOAD');
});
